import { Component, HostBinding, Input } from "@angular/core";

@Component({
  selector: "app-button",
  templateUrl: "./button.component.html",
  styleUrls: ["./button.component.scss"]
})
export class ButtonComponent {
  @Input() text = "";
  @Input() icon = "";
  @Input() type = "button";
  @Input() disabled = false;
  @Input() loading = false;
  @Input() backgroundColor = "var(--blue-500)";
  @Input() textAlign: "center" | "flex-start" = "center";
  @Input() color = "white";
  @Input() fullWidth = false;
  /** Altura reduzida, mantendo o tamanho do texto (ex.: rodapé de modal). */
  @Input() dense = false;

  @HostBinding("style.opacity")
  get opacity() {
    return this.disabled ? 0.5 : 1;
  }

  @HostBinding("style.width")
  get width() {
    return this.fullWidth ? "100%" : "fit-content";
  }

  get isDisabled() {
    return this.disabled || this.loading;
  }

  get displayIcon() {
    return this.loading ? "pi-spin pi-spinner" : this.icon;
  }
}
